import DriverTaxiDriverAssociationsResponse, {
  DriverTaxiDriverAssociationsResponseData,
} from "../../../../api/raily/driver/taxi-driver/associations/driver-taxi-driver-associations.response";
import DriverTaxiDriverAssociations, {
  DriverTaxiDriverAssociationsData,
} from "./driver-taxi-driver-associations";

const createDataItem = (
  dataItem: DriverTaxiDriverAssociationsResponseData,
): DriverTaxiDriverAssociationsData => {
  return {
    id: dataItem.id,
    taxiCorporation: dataItem.taxiCorporation,
  };
};

const createData = (
  data: DriverTaxiDriverAssociationsResponseData[],
): DriverTaxiDriverAssociationsData[] => {
  return data.map(createDataItem);
};

const create = (
  response: DriverTaxiDriverAssociationsResponse,
): DriverTaxiDriverAssociations => {
  return createData(response.data);
};

const driverTaxiDriverAssociationsFactory = {
  create,
};

export default driverTaxiDriverAssociationsFactory;
